import React, { useState, useEffect } from 'react';
import { Box, Button, Modal, Typography } from '@mui/material';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import axios from 'axios';
import styles from './MediaPosts.module.css';
import { Link, useNavigate } from 'react-router-dom';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: 600,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: '8px',
};

const MediaPosts = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [selectedPost, setSelectedPost] = useState(null);
    const [formValues, setFormValues] = useState({
        title: '',
        category: '',
        subCategory: '',
        url: '',
        link: ''
    });
    const navigate = useNavigate();

    const fetchPosts = async () => {
        try {
            const res = await axios(`${process.env.REACT_APP_COSMOSADMIN}/meta/getArticles`);
            setPosts(res.data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPosts();
    }, []);

    const handleOpenModal = (post) => {
        setSelectedPost(post);
        if (post) {
            setFormValues({
                title: post.title,
                category: post.category,
                subCategory: post.subCategory,
                url: post.url,
                link: post.link
            });
        }
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedPost(null);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value });
    };

    const handleSaveChanges = async () => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_COSMOSADMIN}/meta/updateArticle/${selectedPost.id}`, formValues);
            fetchPosts();
            handleCloseModal();
        } catch (error) {
            console.error(error);
        }
    };

    const handleDeletePost = async (id) => {
        try {
            await axios.delete(`${process.env.REACT_APP_COSMOSADMIN}/meta/deleteArticle/${id}`);
            fetchPosts();
        } catch (error) {
            console.error(error);
        }
    };

    const handleEditPost = (post) => {
    navigate(`/media/create-posts/${post.id}`);
};


    return (
        <div className={styles.mediaMain}>
            <div className={styles.mediaContent}>
                <div className={styles.headerSection}>
                    <Typography variant="h4" className={styles.mediaHeader}>
                        Media Posts
                    </Typography>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Button variant="contained" onClick={() => navigate("/media/create-posts")}>Create Post</Button>
                        <Typography variant='body1' className={styles.mediaItem}>
                            <MoreVertIcon
                                sx={{ color: '#16469d', cursor: 'pointer' }}
                                onClick={() => handleOpenModal(null)}
                            />
                        </Typography>
                    </div>
                </div>
                <div className={`${styles.mediaComponent} ${styles.mediaHeaderRow}`} style={{ width: '100%' }}>
                    <Typography variant='subtitle1' className={styles.mediaHeaderItem} sx={{ width: '20%' }}>Title</Typography>
                    <Typography variant='subtitle1' className={styles.mediaHeaderItem} sx={{ width: '20%' }}>Category</Typography>
                    <Typography variant='subtitle1' className={styles.mediaHeaderItem} sx={{ width: '20%' }}>Subcategory</Typography>
                    <Typography variant='subtitle1' className={styles.mediaHeaderItem} sx={{ width: '10%' }}>Images</Typography>
                    <Typography variant='subtitle1' className={styles.mediaHeaderItem} sx={{ width: '10%' }}>Link</Typography>
                    <Typography variant='subtitle1' className={styles.mediaHeaderItem} sx={{ width: '10%' }}>Last Modified</Typography>
                    <Typography variant='subtitle1' className={styles.mediaHeaderItem} sx={{ width: '10%' }}>Action</Typography>
                </div>
                {posts.map((post, index) => (
                    <Box key={index} className={styles.mediaComponent}>
                        <div className={`${styles.mediaComponent} ${styles.mediaHeaderRow}`} style={{ width: '100%' }}>
                            <Typography variant='body1' className={styles.mediaItem} sx={{ fontSize: '14px', }}>
                                {post.title}
                            </Typography>
                            <Typography variant='body1' className={styles.mediaItem} sx={{ width: '20%' }}>{post.category}</Typography>
                            <Typography variant='body1' className={styles.mediaItem} sx={{ width: '20%' }}>{post.subCategory}</Typography>
                            <Typography variant='body1' className={styles.mediaItem} sx={{ width: '10%' }}>
                                <img src={post.url} alt="" style={{ width: '50%' }} />
                            </Typography>
                            <Typography variant='body1' className={styles.mediaItem} sx={{ width: '10%' }}>
                                <Link to={post.link} className={styles.mediaLink}>Visit</Link>
                            </Typography>
                            <Typography variant='body1' className={styles.mediaItem} sx={{ width: '10%' }}>{post.updatedOn.split("T")[0]}</Typography>
                            <Typography variant='body1' className={styles.mediaItem} sx={{ width: '10%' }}>
                                <BorderColorOutlinedIcon onClick={() => handleEditPost(post)} sx={{ color: '#16469d', cursor: 'pointer' }} />
                                <DeleteOutlineIcon onClick={() => handleDeletePost(post.id)} sx={{ color: '#16469d', cursor: 'pointer' }} />
                            </Typography>
                        </div>
                    </Box>
                ))}
            </div>
        </div>
    );
}

export default MediaPosts;
